import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Card, CardContent, Chip, Typography } from '@mui/material';
import './DomainChoicePage.css';

const options = [
  {
    tier: '$1 Tier',
    title: 'Modern Domain Plan',
    price: '$1.00 / month',
    purchaseLabel: 'Starter Creator (Modern Domain Plan)',
    href: 'https://buy.stripe.com/28E3cw3Mc6VYdLyaT43Je09',
    description:
      'Best for creators who want a clean custom domain on day one without overpaying. You get managed hosting, a fast site, and a brandable web presence that is easy to share across TikTok, Instagram, and YouTube.',
    highlight: 'Choose from .xyz or .site and launch fast with a low monthly commitment.',
  },
  {
    tier: '$2 Tier',
    title: 'Premium .com Plan',
    price: '$2.00 / month',
    purchaseLabel: 'Elite Brand (Premium .com Plan)',
    href: 'https://buy.stripe.com/4gMbJ22I8a8a9vid1c3Je0a',
    description:
      'For brands ready to lead with a premium identity. This plan gives you a custom .com with hosting and management included, so your business looks established and trustworthy from the first click.',
    highlight: 'Ideal when credibility and long-term brand value are the priority.',
  },
];

const reasons = [
  'Blazing fast: hosted on Netlify so links load instantly during viral spikes.',
  'Zero fees: unlike platforms that take a cut of sales, you keep 100% of revenue.',
  'True ownership: you own the domain. No platform prefixes or rented links.',
];

const DomainChoicePage = () => {
  return (
    <main className="domain-choice-page">
      <section className="domain-choice-hero">
        <Container maxWidth="lg">
          <div className="domain-choice-hero-inner">
            <Chip label="Digital real estate" className="domain-choice-chip" />
            <Typography component="h1" className="domain-choice-title">
              Take Control of Your Digital Real Estate
            </Typography>
            <Typography className="domain-choice-subtitle">
              Stop sending your fans to a platform that takes a cut of your sales and controls
              your data. Get a custom, lightning-fast site hosted on Netlify, built specifically
              to convert your TikTok traffic.
            </Typography>

            <div className="domain-choice-actions">
              <Button component={Link} to="/wix-exit" variant="contained" className="domain-choice-primary">
                Back to Wix exit
              </Button>
              <Button
                component="a"
                href="mailto:ecbjr.it@gmail.com?subject=Domain%20Choice%20Question"
                variant="outlined"
                className="domain-choice-secondary"
              >
                Ask a question
              </Button>
            </div>
          </div>
        </Container>
      </section>

      <section className="domain-choice-content">
        <Container maxWidth="lg">
          <div className="domain-choice-grid">
            {options.map((option) => (
              <Card key={option.tier} className="domain-choice-card">
                <CardContent className="domain-choice-card-content">
                  <Typography className="domain-choice-tier">{option.tier}</Typography>
                  <Typography variant="h4" component="h2" className="domain-choice-card-title">
                    {option.title}
                  </Typography>
                  <Typography className="domain-choice-price">{option.price}</Typography>
                  <Typography className="domain-choice-description">{option.description}</Typography>
                  <div className="domain-choice-highlight">{option.highlight}</div>
                  <Button
                    component="a"
                    href={option.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    className="domain-choice-buy"
                  >
                    Choose {option.purchaseLabel}
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </Container>
      </section>

      <section className="domain-choice-pricing">
        <Container maxWidth="lg">
          <div className="domain-choice-pricing-panel">
            <Typography variant="h3" component="h2" className="domain-choice-section-title">
              Simple plan structure
            </Typography>

            <div className="domain-choice-table" role="table" aria-label="Domain choice pricing">
              <div className="domain-choice-table-row domain-choice-table-head" role="row">
                <div role="columnheader">Plan</div>
                <div role="columnheader">Feature</div>
                <div role="columnheader">Pricing</div>
              </div>
              <div className="domain-choice-table-row" role="row">
                <div role="cell">Starter Creator</div>
                <div role="cell">Custom .xyz or .link domain + Hosting</div>
                <div role="cell">
                  <a href="https://buy.stripe.com/28E3cw3Mc6VYdLyaT43Je09" target="_blank" rel="noopener noreferrer">
                    $1 / month
                  </a>
                </div>
              </div>
              <div className="domain-choice-table-row" role="row">
                <div role="cell">Elite Brand</div>
                <div role="cell">Custom .com domain + Hosting</div>
                <div role="cell">
                  <a href="https://buy.stripe.com/4gMbJ22I8a8a9vid1c3Je0a" target="_blank" rel="noopener noreferrer">
                    $2 / month
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="domain-choice-reasons">
        <Container maxWidth="lg">
          <div className="domain-choice-reasons-panel">
            <Typography variant="h3" component="h2" className="domain-choice-section-title">
              Why make the switch?
            </Typography>
            <div className="domain-choice-reasons-grid">
              {reasons.map((reason) => (
                <div key={reason} className="domain-choice-reason">
                  {reason}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default DomainChoicePage;
